import { render, staticRenderFns } from "./ProductionPrepDetail.vue?vue&type=template&id=38ed546e&"
import script from "./ProductionPrepDetail.vue?vue&type=script&lang=ts&"
export * from "./ProductionPrepDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports